// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__DdOwX","meals-appear":"AvailableMeals_meals-appear__RoRcf"};